<mat-autocomplete autoActiveFirstOption>
  @if (!displayInterlocutors) {
    @if (withFavorites && hasFavorites()) {
      <mat-option class="favs-option" (onSelectionChange)="selectFavorites($event, favorites())">
        <app-apply-all-favorite-option [favoriteCount]="favoriteCount()" />
      </mat-option>
    }
    @for (contributor of data; track trackById($index, contributor)) {
      <mat-option (onSelectionChange)="emitSelect($event, contributor)" [value]="contributor">
        @if (contributor.id) {
          <app-contributor-option
            [contributor]="contributor"
            [withFavorites]="withFavorites"
            [favorite]="withFavorites && (favorites() | includes: contributor.id)"
            (addToFavorites)="addToFavs(contributor)"
            (removeFromFavorites)="removeFromFavs(contributor)"
          />
        } @else {
          {{ nullOptionLabel }}
        }
      </mat-option>
    }
  } @else {
    <div class="interlocutors-container">
      <mat-optgroup label="Intervenants du dossier">
        @for (interlocutor of interlocutors; track trackById($index, interlocutor)) {
          <mat-option [value]="interlocutor" (onSelectionChange)="emitSelect($event, interlocutor.user)">
            <app-contributor-option [contributor]="interlocutor.user" />
          </mat-option>
        }
      </mat-optgroup>
      @if (!interlocutors.length) {
        <div class="text-container no-results">
          <span>Aucun intervenant affecté à ce dossier</span>
        </div>
      }
      <mat-optgroup label="Tous les intervenants">
        @for (contributor of data; track trackById($index, contributor)) {
          <mat-option [value]="contributor" (onSelectionChange)="emitSelect($event, contributor)">
            <app-contributor-option [contributor]="contributor" />
          </mat-option>
        }
      </mat-optgroup>
    </div>
  }
</mat-autocomplete>
